/*eslint-disable */
import toast from '@/services/toast';
const $ = window.jQuery = require('jquery'); 
import {
  bus
} from '@/main';
export default {
  name: 'clear-all-trash',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    getPaperPileListAgain(){
      this.$store.dispatch('getTrashPaperListFun')
      this.$store.dispatch('getTrashFolderListFun')
    },
    closeAllTrashPaperModalFun(){
      bus.$emit('clearAllTrshPaperBus', false)
      $('body').removeClass('body_right_scroll_remove')
    },
   clearAllTrashPaperConfirmFun(){
      this.$store.dispatch('clearAllTrashOfPapperFun').then
      ((res) => {
        toast.success(res.data.msg);
        this.getPaperPileListAgain()
        this.closeAllTrashPaperModalFun()
      }).catch((err) => {
        toast.error(err.data.user_msg || err.data.msg);
      })
    }

  }
}


